import React from "react";
import { useUserContext } from "context/UserContext";
import ManufacturerBK from "layouts/BK/manufacturer";
import { isBkLikeRole } from "utils/roleUtils";

function Manufacturer() {
  const { role } = useUserContext() || {};
  if (isBkLikeRole(role)) {
    return <ManufacturerBK />;
  }
  return null;
}

export default Manufacturer;
